import LOGO from "../images/pythons.png";

export const Team__Pythons = {
  name: "Pythons",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#d500a7ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 2,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 29 + 22 + 40 + 16,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 28 + 23 + 37 + 37,
    },
  ],
};
